import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useIdleTimer } from "react-idle-timer";
import { connect } from "react-redux";
import { Router } from "react-router-dom";
import { StyleSheetManager } from "styled-components";
import rtlPlugin from "stylis-plugin-rtl";
import "./App.css";
import i18n from "./i18n";
import { isRtl } from "./i18n/helpers";
import { history } from "./modules/history.js";
import { mapDispatchToPropsLogin, mapStateToPropsLogin } from "./modules/login";
import Routes from "./router/components/Routes";
import {
  default as routes,
  onProtectedRouteChange,
  onRouteChange,
  root as defaultRoute,
} from "./router/routes";
import MouseFollowingArrow from "./components/library/MouseFollowingArrow/MouseFollowingArrow";

const App = (props) => {
  const { sessionTimeout, token } = props;

  const [isRtlApp, setIsRtlApp] = useState(isRtl());

  const handleOnIdle = () => {
    //If logged
    if (token) {
      sessionTimeout();
    }
  };

  useIdleTimer({
    timeout: 600000,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  useEffect(() => {
    i18n.on("languageChanged", () => {
      setIsRtlApp(isRtl());
    });
  }, []);

  return (
    <StyleSheetManager stylisPlugins={isRtlApp ? [rtlPlugin] : []}>
      <Router history={history}>
        <Routes
          routes={routes}
          default={defaultRoute}
          {...{ onRouteChange }}
          {...{ onProtectedRouteChange }}
          {...props}
        />
        <MouseFollowingArrow />
      </Router>
    </StyleSheetManager>
  );
};

const mapDispatchToProps = {
  logout: mapDispatchToPropsLogin.logout,
  sessionTimeout: mapDispatchToPropsLogin.sessionTimeout,
  setOpenAuthModal: mapDispatchToPropsLogin.setOpenAuthModal,
};

const mapStateToProps = (state) => ({
  ...mapStateToPropsLogin(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
